import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function VoiceOnKeyPress(value, key, eventId): any;
declare var $: any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function browseobligorvoiceOnKeyPress(value, key, targetid): any;
declare function FontSizeSettings(): any;
@Component({
  selector: 'app-cusip',
  templateUrl: './cusip.component.html',
  styleUrls: ['./cusip.component.css']
})
export class CusipComponent implements OnInit {
  public IssuerCTCUSIPsArray = [];
  public IssuerCTCUSIPs: any;
  public IsShifttab = 0;
  public obligorId = localStorage.getItem("OBLIGOR_ID");
  constructor(private router: Router,private issuerAPIService: IssuerAPIService) { }

  GobackPage() {
    localStorage.setItem("PPC", "2");
    this.router.navigate(['/compliance-review']);
    return;
  }
  onKeyUp(event: any) {
    debugger;

    if (event.target.id == "returnbackProcedure" && event.keyCode == 13) {
      this.GobackPage();
    }

    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
      if (event.target.value.length > 0) {
        VoiceOnKeyPress(event.target.value, event.key, event.target.id);
        btnSearch.disabled = false;
        btnClear.disabled = false;
      }
      else {
        btnSearch.disabled = true;
        btnClear.disabled = true;
      }
    }

    //if (event.target.id == "btnSearch" && event.keyCode == 13) {
    //  debugger;
    //  this.onCusipSearch();
    //  return;
    //}
    // add tab shift to go to return button
    if (event.shiftKey && event.keyCode == 9 && (event.target.id == "tdCUSIP")) {
      document.getElementById("returnback").focus();
      this.IsShifttab = 1;
      responsiveVoiceSpeak("", "Return back to filing history page. Press enter to return back to Filling History page or use tab to go to the text field.");

    }
    if ((event.keyCode == 16) && (event.target.id == "tdCUSIP")) {
      document.getElementById("returnback").focus();
      this.IsShifttab = 1;
      responsiveVoiceSpeak("", "Return back to filing history page. Press enter to return back to Filling History page or use tab to go to the text field.");

    }
    if (event.target.id == "returnback" && event.keyCode == 9) {
      if (this.IsShifttab == 0) {
        responsiveVoiceSpeak("", "Return back to filing history page. Press enter to return back to Filling History page or use tab to go to the text field.");
      }
      else {
        this.IsShifttab = 0;
      }
      return;
    }
    
    if (event.target.id == "btnclear" && event.keyCode == 13) {
      this.onClear();
    }

    if (event.target.id == "cusippnp" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Cusips. Heading 1. This page lists all available cusips. You can also search for a specific cusip. Use escape to exit the list or use tab to go to the next field.");
    }
    if (event.target.id == "inputSuccess5" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Search box. Input a cusip number to search or use tab to go to the cusips list.");
    }
    
    if (event.target.id == "btnSearch" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Search button. Press enter to search for the cusips or use tab to go the clear button.");
    }
    if (event.target.id == "btnClear" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Clear button. Press enter to clear the search result or use tab to go to the list.");
    }

    if (event.target.id == "tdCUSIP" && (event.shiftKey && event.keyCode == 9)) {
      document.getElementById("returnback").focus();
      responsiveVoiceSpeak("", "Return back to filing history page. Press enter to return back to Filling History page or use tab to go to the text field.");
    }

    if (event.target.id == "tdCUSIP" && (event.keyCode == 16)) {
      document.getElementById("returnback").focus();
      responsiveVoiceSpeak("", "Return back to filing history page. Press enter to return back to Filling History page or use tab to go to the text field.");
    }
    
    if (event.target.id == "tdCUSIP" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      ///responsiveVoiceSpeak("", event.target.innerText +". Use tab to go next field.");
     // responsiveVoiceSpeak("", event.target.innerText);
    }
    if (event.target.id == "tdCUSIP" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
    }

    if (event.target.id == "tdCUSIP" && (event.shiftKey && event.keyCode == 9)) {
      document.getElementById("inputSuccess5").focus();
      responsiveVoiceSpeak("", "Search box. Input a cusip number to search or use tab to go to the cusips list.");
    }

    if (event.keyCode != 17) {

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        this.UpArrowKey(event);
        return;
      }
      else if (event.keyCode == 40) {
        debugger;
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        this.DownArrowKey(event, child_cell);
        return;
      }
      else if (event.keyCode == 39) {
        debugger;
        var child_cell = $(event.target).index();
        this.RightArrowKey(event, child_cell);
        return;

      }
      else if (event.keyCode == 37) {
        var child_cell = $(event.target).index();
        this.LeftArrowKey(event, child_cell)
        return;
      }

    }
  };
  ngOnInit() {
    debugger;

    if (localStorage.getItem("PPC")) {
      localStorage.removeItem("PPC");
    }

    var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
    var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
    btnSearch.disabled = true;
    btnClear.disabled = true;

    // Get OBLIGOR_ID from local Storage.

    this.loadIssuerCTCUSIPs(this.obligorId);
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    this.MagnifieronDynamicChecking();
    responsiveVoiceSpeak("", "This is Cusip page. Use tab to go to the next field.");    
     //end
  }
  onkeypress(event: any) {

    debugger;
   // Enable/Disable search button on the Obligor Name Search Box.
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
      if (event.target.value.length> 0) {
        btnSearch.disabled = false;
        btnClear.disabled = false;
      }
      else {
        btnSearch.disabled = true;
        btnClear.disabled = true;
      }
    }

    //if ((event.target.id == "inputSuccess5") && (event.keyCode > 46)) {

      
    //    VoiceOnKeyPress(event.target.value, event.key, event.target.id);
      
      
      
    //}

   //Set value for obligorId and obligorDesc for all components.
    if (event.target.id == "inputSuccess5") {
      if (event.keyCode != 17 && event.keyCode != 0) {
        browseobligorvoiceOnKeyPress(event.target.value, event.key, event.target.id);
      }
    }
    else if (event.keyCode == 32) {
      if (event.target.id == "btnClear" || event.target.id == "btnSearch") {
        event.preventDefault();
        return;
      }
    }

  }
  // Load Issuer CT CUSIPs
  DownArrowKey(event: any, child_cell: string) {
    debugger;
    var innerText, title;
    if (event.target.id == "tdCUSIP") {

      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;


        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }

  }
  UpArrowKey(event: any) {
    debugger;
    var child_cell = $(event.target).index(), innerText, title;
    if (event.target.id == "tdCUSIP") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }


  }
  LeftArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdobligorState") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdobligorName") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdobligorName") {
      var target = $(event.target).next();

      if (target[0].id == "tdobligorState") {
        $(event.target).parent().prev().children("td").eq(1).focus();
        $('#hdlastRow').val('0');
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)


      }
    }
  }
  RightArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdobligorName") {
      debugger;
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdobligorState") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }


        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }

    if (event.target.id == "tdobligorState") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdobligorState") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdobligorName", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }


  }

  loadIssuerCTCUSIPs(obligorId: string) {
   // document.getElementById("overlay").style.display = "block";
    this.issuerAPIService.GetIssuerCTCUSIPs(obligorId).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
    debugger;
      this.IssuerCTCUSIPs = data;
    for (var item in this.IssuerCTCUSIPs) {
      var objData = this.IssuerCTCUSIPs[item];
      var jsonObj = [];
      for (var i = 0; i < objData.length; i++) {
        var objrecords = {}
        objrecords["CUSIPs"] = objData[i];
        jsonObj.push(objrecords);
      }
      var CUSIPsJSON = { "label": item, "records": jsonObj };
      this.IssuerCTCUSIPsArray.push(CUSIPsJSON);
      
    }
    });
  }
  onCusipSearch() {
    
    debugger;
     var searchvalue = <HTMLInputElement>document.getElementById("inputSuccess5");
      var serachI = searchvalue.value.toLowerCase();
      //var index = 0;
     $(".divhead").css("display", "none");
      var countrows_headwise = 0;
      $("table").each(function (index) {
        $(this).find("tr").filter(function () {
          
          if ($(this).text().toLowerCase().indexOf(serachI) > -1) {
            $("#head_" + index).css("display", "block");
            countrows_headwise = countrows_headwise + 1;
          }
          $(this).toggle($(this).text().toLowerCase().indexOf(serachI) > -1);
        });
      });

      var countRows = countrows_headwise;
      if (countRows > 0)
        responsiveVoiceSpeak("", countRows.toString() + " cusips found.  Use tab to go the clear button.");
      else
        responsiveVoiceSpeak("", "No cusip found.  Use tab to go the clear button.");
   
  }
  onClear() {
    var searchvalue = <HTMLInputElement>document.getElementById("inputSuccess5");
    searchvalue.value = "";
    $("table").each(function (index) {
      $(this).find("tr").splice(index, 1);
    });

    responsiveVoiceSpeak("", "Search result cleared. Use tab to go to the list.");
    document.getElementById("inputSuccess5").focus();
    this.IssuerCTCUSIPsArray = [];
    this.loadIssuerCTCUSIPs(this.obligorId);
    this.MagnifieronDynamicChecking();
    return;
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
 
}
